import App from './App';
import Detalle from './containers/Detalle/Detalle';
import Home from './containers/Home/Home';

const routes = [
    {
        component: App,
        routes: [
            { path: '/', exact: true, component: Home },
            { path: '/r/:rubro2/modelos/:modelosParams/(clasificado)?/:clasificadoid?', exact: false, component: Detalle }
        ]
    }
];

export default routes;